// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25UjE","left":"styles_left__2w7sX"};